webpackJsonp([232863481103816],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background_2020.9b904c68.png";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _background_ = __webpack_require__(25);
	
	var _background_2 = _interopRequireDefault(_background_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var conferencePostponed = function conferencePostponed() {
		return _react2.default.createElement(
			'section',
			{ id: 'interview', className: 'parallax-section' },
			_react2.default.createElement(
				'div',
				{ className: 'container' },
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-md-12 col-sm-12 wow fadeInUp', 'data-wow-delay': '0.1s' },
						_react2.default.createElement(
							'div',
							{ className: 'team-wrapper' },
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-4' },
									_react2.default.createElement('img', { src: _background_2.default, className: 'img-responsive', alt: 'The Good Pressure Edition' })
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-8' },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement(
											'h3',
											null,
											'DevExperience 2020 The one with The Good Pressure - technology and meaning, is postponed'
										),
										_react2.default.createElement(
											'p',
											null,
											'Due to national and international decisions and recommendations concerning public health our event is postponed for the autumn 2020. ',
											_react2.default.createElement('br', null)
										)
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12' },
									_react2.default.createElement(
										'p',
										null,
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										'Dear guests, partners, and participants at DevExperience 2020, we really need to inform you that our conference scheduled for 26-28 of March has to be postponed to September/October, due to national and international decisions and recommendations concerning public health. ',
										_react2.default.createElement('br', null),
										'If you already purchased a ticket, you can contact us to receive refunds, or you can maintain your seat for September/October. We sympathize with the whole tech conference organizers out there, and we will keep you posted with news and solutions.',
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										_react2.default.createElement('br', null),
										'Dragi invita\u021Bi, parteneri \u0219i participan\u021Bi la DevExperience 2020, programat\u0103 s\u0103 aib\u0103 loc \xEEntre 26-28 Martie, v\u0103 anun\u021B\u0103m c\u0103, \xEEn urma noilor decizii interna\u021Bionale \u0219i na\u021Bionale cu privire la protec\u021Bia \u0219i siguran\u021Ba public\u0103, suntem nevoi\u021Bi s\u0103 am\xE2n\u0103m evenimentul pentru luna septembrie/octombrie. ',
										_react2.default.createElement('br', null),
										'Cei care \u0219i-au achizi\u021Bionat deja bilete ne pot contacta pentru returnarea investi\u021Biei sau \xEE\u0219i pot p\u0103stra locurile pentru edi\u021Bia din septembrie/octombrie. Suntem al\u0103turi de \xEEntreaga comunitate de organizatori de evenimente \xEEn #IT \u0219i v\u0103 \u021Binem la curent cu nout\u0103\u021Bile din industrie, c\u0103ut\xE2nd solu\u021Bii.'
									)
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = conferencePostponed;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-conference-postponed-js-1484588b5532f55bad8f.js